import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle",
  "use": "circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"circle\"><g transform=\"translate(0 -1028.362)\"><circle fill=\"#ebebeb\" cy=\"1040.272\" cx=\"12.1\" r=\"10.509\" /><circle stroke-width=\".999\" stroke-dashoffset=\".168\" stroke-dasharray=\"1.99829691 .99914846\" stroke=\"currentColor\" r=\"10.5\" fill=\"none\" cy=\"1040.362\" cx=\"12\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol